import React from 'react';

interface GoLinkProps {
    fill?: string;
}

export const GoLink = ({ fill = 'currentColor' }: GoLinkProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_862_6099)">
            <path
                d="M7.125 6.70545L7.875 5.95267V10.4467H1.5V5.19666C1.5 4.57416 2.00625 4.07166 2.625 4.07166H6.1204L5.3692 4.82166H2.625C2.41875 4.82166 2.25 4.99041 2.25 5.19666V9.69666H7.125V6.70545Z"
                fill={fill}
            />
            <path
                d="M8.51153 2.75174L5.03522 2.74908L5.03522 3.49685L7.98385 3.49685L3.99106 7.48965L4.52404 8.02263L8.51418 4.03248L8.51418 7.00763L9.26195 7.00764L9.26195 3.50215C9.26195 3.08849 8.92519 2.75174 8.51153 2.75174Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_862_6099">
                <rect width="9" height="9" fill="white" transform="translate(1.5 1.5)" />
            </clipPath>
        </defs>
    </svg>
);
